package com.appsyde.shared.network

import com.appsyde.contract.ErrorResponseDto // <-- ajuste le package exact
import com.appsyde.shared.network.exception.InsufficientScopesException
import com.appsyde.shared.network.exception.NotAuthenticatedException
import com.appsyde.shared.network.exception.RemoteApiException
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.HttpStatusCode
import io.ktor.http.isSuccess
import kotlinx.serialization.json.Json

private val json = Json { ignoreUnknownKeys = true }

private fun parseErrorOrNull(raw: String): ErrorResponseDto? =
    runCatching { json.decodeFromString<ErrorResponseDto>(raw) }.getOrNull()

private fun throwFromErrorDto(
    httpStatus: HttpStatusCode,
    raw: String,
    fallbackCode: String
): Nothing {
    val err = parseErrorOrNull(raw)

    val code = err?.code ?: fallbackCode
    val message = err?.message ?: "Request failed with status ${httpStatus.value}"

    when (code) {
        "not_authenticated" -> throw NotAuthenticatedException(message)
        "insufficient_scopes" -> throw InsufficientScopesException(message)
        else -> throw RemoteApiException(
            code = code,
            message = message,
            requestId = err?.requestId,
            fields = err?.fields,
            httpStatus = httpStatus.value,
            rawBody = raw
        )
    }
}

/** Lis le body, et si status != 2xx -> throw une exception typée, sinon retourne le body. */
suspend fun HttpResponse.requireSuccessOrBody(fallbackCode: String): String {
    val raw = bodyAsText()
    if (!status.isSuccess()) throwFromErrorDto(status, raw, fallbackCode)
    return raw
}
